export default __webpack_public_path__ + "static/media/764.88d0c742.png";